export function getRuleImpactLabel(item) {
    const ruleName = normalise(item?.ruleName)
    const ruleId = normalise(item?.ruleId)
    const ruleSetName = normalise(item?.ruleSetName)

    if (ruleSetName && (!ruleName || ruleName === ruleId)) return ruleSetName
    return ruleName || ruleSetName || ruleId
}

function normalise(value) {
    return String(value || "").trim()
}
